// extracted by mini-css-extract-plugin
export default {"productWrapper":"Products_productWrapper__jH9p0","title":"Products_title__t7xk+","buttons":"Products_buttons__b3Jlc","point":"Products_point__l6XuC"};